module.exports = __webpack_public_path__ + "static/Flavor-German-Amarillo-T45-VA18000295-4e0913b6db5118659c69fe57d28c41d6.pdf";